<div class="drawer-wrapper" fxLayout="column" fxLayoutGap="24px">
  <div class="title">Zone Editor tool</div>
  <div class="tab-list">
    <mat-tab-group mat-align-tabs="start"
      [selectedIndex]="selectedTabIndex"
      [disablePagination]="true"
      [disableRipple]="true">
      <mat-tab label="Zones">
        <ng-template matTabContent>
          Zones list works!
          <button (click)="navigateToCreateZoneForm()">Create zone</button>
        </ng-template>
      </mat-tab>
      <mat-tab label="Categories">
        <ng-template matTabContent>
          <app-category-content fxLayout="column" fxLayoutGap="24px"></app-category-content>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
